import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-wizard-step-basic',
  templateUrl: './wizard-step-basic.component.html',
  styleUrls: ['./wizard-step-basic.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class WizardStepBasicComponent {
  @Input() formGroup!: FormGroup;
}
